/**
* Template Name: KnightOne
* Template URL: https://bootstrapmade.com/knight-simple-one-page-bootstrap-template/
* Updated: Oct 16 2024 with Bootstrap v5.3.3
* Author: BootstrapMade.com
* License: https://bootstrapmade.com/license/
*/

(function() {
  "use strict";

  /**
   * Apply .scrolled class to the body as the page is scrolled down
   */
  function toggleScrolled() {
    const selectBody = document.querySelector('body');
    const selectHeader = document.querySelector('#header');
    if (!selectBody || !selectHeader) return;
    if (!selectHeader.classList.contains('scroll-up-sticky') && !selectHeader.classList.contains('sticky-top') && !selectHeader.classList.contains('fixed-top')) return;
    window.scrollY > 100 ? selectBody.classList.add('scrolled') : selectBody.classList.remove('scrolled');
  }

  document.addEventListener('scroll', toggleScrolled);
  window.addEventListener('load', toggleScrolled);

  /**
   * Mobile nav toggle
   */
  const mobileNavToggleBtn = document.querySelector('.mobile-nav-toggle');

  function mobileNavToogle() {
    document.querySelector('body').classList.toggle('mobile-nav-active');
    mobileNavToggleBtn.classList.toggle('bi-list');
    mobileNavToggleBtn.classList.toggle('bi-x');
  }
  if (mobileNavToggleBtn) {
    mobileNavToggleBtn.addEventListener('click', mobileNavToogle);
  }

  /**
   * Hide mobile nav on same-page/hash links
   */
  document.querySelectorAll('#navmenu a').forEach(navmenu => {
    navmenu.addEventListener('click', () => {
      if (document.querySelector('.mobile-nav-active')) {
        mobileNavToogle();
      }
    });

  });

  /**
   * Toggle mobile nav dropdowns
   */
  document.querySelectorAll('.navmenu .toggle-dropdown').forEach(navmenu => {
    navmenu.addEventListener('click', function(e) {
      e.preventDefault();
      this.parentNode.classList.toggle('active');
      this.parentNode.nextElementSibling.classList.toggle('dropdown-active');
      e.stopImmediatePropagation();
    });
  });

  /**
   * Scroll top button
   */
  let scrollTop = document.querySelector('.scroll-top');

  function toggleScrollTop() {
    if (scrollTop) {
      window.scrollY > 100 ? scrollTop.classList.add('active') : scrollTop.classList.remove('active');
    }
  }
  if (scrollTop) {
    scrollTop.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }

  window.addEventListener('load', toggleScrollTop);
  document.addEventListener('scroll', toggleScrollTop);

  /**
   * Animation on scroll function and init
   */
  function aosInit() {
    if (typeof AOS === 'undefined') return;
    AOS.init({
      duration: 600,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }
  window.addEventListener('load', aosInit);

  /**
   * Frequently Asked Questions Toggle
   */
  document.querySelectorAll('.faq-item h3, .faq-item .faq-toggle').forEach((faqItem) => {
    faqItem.addEventListener('click', () => {
      faqItem.parentNode.classList.toggle('faq-active');
    });
  });

  /**
   * Init swiper sliders
   */
  function initSwiper() {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll(".init-swiper").forEach(function(swiperElement) {
      let config = JSON.parse(
        swiperElement.querySelector(".swiper-config").innerHTML.trim()
      );

      if (config.navigation) {
        if (typeof config.navigation.nextEl === "string") {
          config.navigation.nextEl = swiperElement.querySelector(config.navigation.nextEl);
        }

        if (typeof config.navigation.prevEl === "string") {
          config.navigation.prevEl = swiperElement.querySelector(config.navigation.prevEl);
        }
      }

      if (config.pagination && typeof config.pagination.el === "string") {
        config.pagination.el = swiperElement.querySelector(config.pagination.el);
      }

      if (swiperElement.classList.contains("swiper-tab")) {
        initSwiperWithCustomPagination(swiperElement, config);
      } else {
        new Swiper(swiperElement, config);
      }
    });
  }

  window.addEventListener("load", initSwiper);

  function initCounters() {
    if (typeof CountUp === 'undefined') return;

    const resellerElement = document.getElementById('stats-reseller-partners');
    const uptimeElement = document.getElementById('stats-uptime');
    const experienceElement = document.getElementById('stats-exp');
    if (!resellerElement || !uptimeElement || !experienceElement) return;

    const counters = [
      new CountUp(resellerElement, 0, 50, 0, 8, { prefix: 'R', suffix: ' mil+', duration: 5 }),
      new CountUp(uptimeElement, 0, 10000, 0, 8, { suffix: '+' }),
      new CountUp(experienceElement, 0, 25, 0, 8, {})
    ];

    counters.forEach((counter) => {
      if (!counter.error) {
        counter.start();
      } else {
        console.error(counter.error);
      }
    });
  }

  window.addEventListener('load', initCounters);

  /**
   * Correct scrolling position upon page load for URLs containing hash links.
   */
  window.addEventListener('load', function(e) {
    if (window.location.hash) {
      if (document.querySelector(window.location.hash)) {
        setTimeout(() => {
          let section = document.querySelector(window.location.hash);
          let scrollMarginTop = getComputedStyle(section).scrollMarginTop;
          window.scrollTo({
            top: section.offsetTop - parseInt(scrollMarginTop),
            behavior: 'smooth'
          });
        }, 100);
      }
    }
  });

  /**
   * Navmenu Scrollspy
   */
  let navmenulinks = document.querySelectorAll('.navmenu a');

  function navmenuScrollspy() {
    navmenulinks.forEach(navmenulink => {
      if (!navmenulink.hash) return;
      let section = document.querySelector(navmenulink.hash);
      if (!section) return;
      let position = window.scrollY + 200;
      if (position >= section.offsetTop && position <= (section.offsetTop + section.offsetHeight)) {
        document.querySelectorAll('.navmenu a.active').forEach(link => link.classList.remove('active'));
        navmenulink.classList.add('active');
      } else {
        navmenulink.classList.remove('active');
      }
    })
  }
  window.addEventListener('load', navmenuScrollspy);
  document.addEventListener('scroll', navmenuScrollspy);

  /**
   * Load decorative background video only when it approaches the viewport.
   */
  const lazyVideos = document.querySelectorAll('video source[data-src]');
  if (lazyVideos.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const loadVideo = (source) => {
      const video = source.closest('video');
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
      video.load();
      video.play().catch(() => {});
    };

    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadVideo(entry.target.querySelector('source[data-src]'));
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '300px 0px' });
      lazyVideos.forEach((source) => videoObserver.observe(source.closest('video')));
    } else {
      lazyVideos.forEach(loadVideo);
    }
  }

  const newsroomPage = document.querySelector('.newsroom-page');
  if (newsroomPage) {
    const filterButtons = newsroomPage.querySelectorAll('.filter-btn');
    const articleCards = newsroomPage.querySelectorAll('.article-card');

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const filterValue = button.getAttribute('data-filter');
        const shouldReset = button.classList.contains('active');

        filterButtons.forEach((filterButton) => {
          filterButton.classList.remove('active');
          filterButton.setAttribute('aria-pressed', 'false');
        });

        if (shouldReset) {
          articleCards.forEach((card) => {
            card.hidden = false;
          });
          return;
        }

        button.classList.add('active');
        button.setAttribute('aria-pressed', 'true');

        articleCards.forEach((card) => {
          card.hidden = card.getAttribute('data-category') !== filterValue;
        });
      });
    });
  }

})();
